var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from 'react';
import Link from '../Link/Link';
import Typer from '../Typer/Typer';
/**
 * News components
 */
var News = /** @class */ (function (_super) {
    __extends(News, _super);
    /**
     * News component constructor
     *
     * @param props
     */
    function News(props) {
        var _this = _super.call(this, props) || this;
        /**
         * Close news menu
         */
        _this.closeNewsMenu = function () {
            _this.setState({ newsMenuIsOpen: false });
            var timeout = setTimeout(function () {
                window.removeEventListener('click', _this.closeNewsMenu);
                clearTimeout(timeout);
            }, 200);
        };
        /**
         * Open or close news menu
         */
        _this.toggleNewsMenu = function () {
            var newsMenuIsOpen = _this.state.newsMenuIsOpen;
            if (!newsMenuIsOpen) {
                var timeout_1 = setTimeout(function () {
                    window.addEventListener('click', _this.closeNewsMenu);
                    clearTimeout(timeout_1);
                }, 200);
                _this.setState({ newsMenuIsOpen: !newsMenuIsOpen });
            }
            else {
                _this.closeNewsMenu();
            }
        };
        _this.state = { newsMenuIsOpen: false };
        return _this;
    }
    /**
     * Render news menu
     */
    News.prototype.render = function () {
        var menu = this.props.menu;
        var list = menu.map(function (link) { return ({ title: link.title, url: link.url }); });
        return (React.createElement("div", { id: "digi-news" },
            React.createElement("strong", null, "\u00C0 la une :"),
            React.createElement(Typer, { list: list }),
            React.createElement("div", { id: "news-wrapper" },
                React.createElement("button", { onClick: this.toggleNewsMenu, "aria-label": "Ouvrir ou fermer le menu" }, menu.length),
                React.createElement("ul", { id: "news-list", className: this.state.newsMenuIsOpen ? 'active' : undefined }, menu.map(function (link, index) {
                    var linkProps = __assign(__assign({}, link), { linkId: link.id, id: undefined });
                    return (React.createElement(Link, __assign({ key: link.id, index: index }, linkProps, { children: link.__children, label: link.title, target: "_blank", rel: "noopener" })));
                })))));
    };
    return News;
}(React.Component));
export default News;
//# sourceMappingURL=News.js.map